import { ReactElement } from 'react';

interface SliderProps {
  value: number;
  onChange: (event: any, value: number | number[]) => void;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export default function Slider({
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
}: SliderProps): ReactElement {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value);
    onChange(event, newValue);
  };

  return (
    <div className={`cr-relative cr-w-full ${className}`}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
        className={`
          cr-slider-thumb:cr-appearance-none cr-slider-thumb:cr-w-4 cr-slider-thumb:cr-h-4 
          cr-slider-thumb:cr-rounded-full cr-slider-thumb:cr-bg-white cr-slider-thumb:cr-border-2
          cr-slider-thumb:cr-border-cirrusBlue-100 cr-slider-thumb:cr-shadow-md cr-slider-track:cr-bg-gray-200 
          cr-slider-track:cr-rounded-lg cr-h-2 cr-w-full 
          cr-cursor-pointer cr-appearance-none
          cr-rounded-lg cr-bg-gray-200
          ${disabled ? 'cr-cursor-not-allowed cr-opacity-50' : ''}
        `}
        style={{
          background: `linear-gradient(to right, #3B82F6 0%, #3B82F6 ${((value - min) / (max - min)) * 100}%, 
          #E5E7EB ${((value - min) / (max - min)) * 100}%, #E5E7EB 100%)`,
        }}
      />
    </div>
  );
}
